import React from "react";
import "./Months.css";

const ThisMonth = () => {
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const d = new Date();
  let name = month[d.getMonth()];
  return (
    <div className="thisMonth">
      <span className="month">{name + " - " + d.getFullYear()}</span>
    </div>
  );
};

export default ThisMonth;
